import { BaseService } from './base.service.js';
class RocheService extends BaseService {
    async retrieveMoleculeSdfByReferenceID(referenceId) {
        const res = await this.fetch(`/roche/retrieve-molecule-sdf-by-reference-id/${referenceId}`);
        return res.data;
    }
    async retrieveMolecularImageBySdf(mol) {
        const res = await this.fetch('/roche/retrieve-molecular-image-by-sdf', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                mol_list: [mol],
                format: 'sdfs',
            }),
        });
        return res.data;
    }
}
export const rocheService = new RocheService();
